import { fontFamilyValueToCss } from 'ag-grid-community/dist/types/src/theming/theme-types';
import { Select } from 'antd';
import React, { useState, useEffect, useRef } from 'react';

interface CustomSelectCellEditorProps {
  values: string[]; 
  value: string;
  onValueChange: (value: string) => void;
}

const CustomSelectCellEditor: React.FC<CustomSelectCellEditorProps> = (props) => {
    const { values, value, onValueChange } = props;
    
    const [filteredValues, setFilteredValues] = useState<string[]>(values);
    const [searchText, setSearchText] = useState<string>("");
    const [dropdownVisible, setDropdownVisible] = useState(false);  // Control dropdown visibility
    const [selectValue, setSelectValue] = useState<string>(value);

    const selectRef = useRef<any>(null);
  
    useEffect(() => {
      if (searchText) {
        setFilteredValues(values.filter((v) => v.toLowerCase().startsWith(searchText.toLowerCase())));
      } else {
        setFilteredValues(values);
      }
    }, [searchText, values]);

    useEffect(() => {
      if (filteredValues.length === values.length)
      {
        onValueChange(value);
      }
      else if (filteredValues.length)
      {
        onValueChange(filteredValues[0])
      }
    }, [filteredValues]);

    const handleSelectChange = (selectedValue: string) => {
        onValueChange(selectedValue);
    };

    const handleBlur = () => {
        if (value) {
            onValueChange(value); // Ensure the selected value is saved when editing stops
        }
    };
  
    const handleDropdownVisibleChange = (visible: boolean) => {
      setDropdownVisible(visible);
    };
  
    // Open dropdown automatically when editor is activated
    useEffect(() => {
      if (selectRef.current) {
        setDropdownVisible(true); // Trigger dropdown to be visible when the editor is opened
      }
    }, []);
  
    const handleKeyDown = (event: any) => {

        let updatedSearchText = searchText;

        if (event.key === 'Backspace') {
          updatedSearchText = updatedSearchText.slice(0, updatedSearchText.length - 1);
        } else if (event.key.length === 1 && event.key !== 'Enter') {  
          updatedSearchText += event.key;
        }

        setSearchText(updatedSearchText)
    
        let index = filteredValues.indexOf(value)
        if (event.key === 'ArrowDown') {
            index += 1
            if (index > filteredValues.length - 1)
            {
                index = 0
            }
            onValueChange(filteredValues[index])
        } else if (event.key === 'ArrowUp') {
            if (index == 0)
            {
                index = filteredValues.length
            }
            index -= 1

            onValueChange(filteredValues[index])
        }
    };

    return (
        <Select
          ref={selectRef}
          value={value}
          onChange={handleSelectChange}
          style={{ width: "100%", height: '20px'}}
          onDropdownVisibleChange={handleDropdownVisibleChange}
          open={dropdownVisible}  // Manually control visibility
          autoFocus // Automatically focus when the editor is opened
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
        >
          {filteredValues.map((v) => (
            <Select.Option 
              key={v} 
              value={v} 
              title={
                {
                  N: 'New policy',
                  R: 'Renewal',
                  E: 'Endorsement',
                  C: 'Cancellation',
                  A: 'Audit',
                  X: 'Tax Exempt',
                }[v] || ''
              } 
              style={{fontSize:'12px', fontFamily:'Arial, Verdana, sans-serif'}}>
              {v}
            </Select.Option>
          ))}
        </Select>
    );
  };
export default CustomSelectCellEditor;